<template>
  <div name="input-typework">
    <div class="col-md-12 typework-btn-group-child">
      <div>

        <label class="name-panel">{{ labels['HRMS18E']['150'] }}</label>

          <div class="panel-btn clearfix">
            <input type="radio" id="child-work" value="W" v-model="typework" class="hidden" :disabled="checkTypework"/>
            <label for="child-work" :class="'typework-color-w' + [checkTypework ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'W') ? 'active-w' : '' ]">
              <i :class="'fa ' + [ (typework === 'W') ? 'fa-check-square' : 'fa-square' ]"></i>
              {{labels['HRMS18E']['90']}}
            </label>

            <input type="radio" id="child-holiday" value="H" v-model="typework" class="hidden" :disabled="checkTypework" />
            <label for="child-holiday" :class="'typework-color-h' + [checkTypework ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'H') ? 'active-h' : '' ]">
              <i :class="'fa ' + [ (typework === 'H') ? 'fa-check-square' : 'fa-square' ]"></i>
              {{labels['HRMS18E']['100']}}
            </label>

            <input type="radio" id="child-traditional" value="T" v-model="typework" class="hidden" :disabled="checkTraditional" />
            <label for="child-traditional" :class="'typework-color-t' + [checkTraditional ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'T') ? 'active-t' : '' ]">
              <i :class="'fa ' + [ (typework === 'T') ? 'fa-check-square' : 'fa-square' ]"></i>
              {{labels['HRMS18E']['110']}}
            </label>

            <input type="radio" id="child-leave" value="L" v-model="typework" class="hidden" disabled="disabled" />
            <label for="child-leave" :class="'typework-color-l typework-btn ' + [ (typework === 'L') ? 'active-l' : '' ]">
              <i :class="'fa ' + [ (typework === 'L') ? 'fa-check-square' : 'fa-square' ]"></i>
              {{labels['HRMS18E']['120']}}
            </label>

            <input type="radio" id="child-shutdown" value="S" v-model="typework" class="hidden" :disabled="checkShutdown" />
            <label for="child-shutdown" :class="'typework-color-s' + [checkShutdown ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'S') ? 'active-s' : '' ]">
              <i :class="'fa ' + [ (typework === 'S') ? 'fa-check-square' : 'fa-square' ]"></i>
              {{labels['HRMS18E']['130']}}
            </label>

          </div>
          <div class="line-typework-group"></div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-typework',
  data () {
    return {
      typework: this.childCurrentTypework
    }
  },
  watch: {
    childCurrentTypework (newVal) {
      this.typework = newVal
    },
    typework (newVal) {
      this.setChildTypeworkToTargetTypework({ typework: newVal, targetTypework: this.childTargetTypework })
    }
  },
  computed: {
    checkTypework () {
      return (this.childCurrentTypework === 'L')
    },
    checkTraditional () {
      if (this.childCurrentTypework === 'T' || this.childCurrentTypework === 'S' || this.childCurrentTypework === 'L') {
        return true
      } else if (this.childCurrentTypework === 'H' || this.childCurrentTypework === 'W') {
        if (this.traditionalDayLists) {
          return (this.traditionalDayLists.indexOf(this.childCurrentDay) <= -1)
        } else {
          return true
        }
      }
    },
    checkShutdown () {
      if (this.childCurrentTypework === 'T' || this.childCurrentTypework === 'S' || this.childCurrentTypework === 'L') {
        return true
      } else if (this.childCurrentTypework === 'H' || this.childCurrentTypework === 'W') {
        if (this.shutdownDayLists) {
          return (this.shutdownDayLists.indexOf(this.childCurrentDay) <= -1)
        } else {
          return true
        }
      }
    }
  },
  props: [ 'labels', 'childCurrentDay', 'searchIndex', 'traditionalDayLists', 'shutdownDayLists', 'childCurrentTypework', 'childTargetTypework', 'setChildTypeworkToTargetTypework' ]
}
</script>

<style lang="scss">

.typework-btn-group-child {
  padding: 20px;
  
  .name-panel {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 10px 0;
  }

  .panel-btn {
    /* padding: 5px 10px; */

    .typework-color-w {
      color: #9E9E9E;
      cursor: pointer;
    }
    .typework-color-h {
      color: #D32F2F;
      cursor: pointer;
    }
    .typework-color-t {
      color: #66BB6A;
      cursor: pointer;
    }
   .typework-color-t-not-allow {
      color: #66BB6A;
      cursor: not-allowed;
    }
    .typework-color-s {
      color: #0277BD;
      cursor: pointer;
    }
   .typework-color-s-not-allow {
      color: #0277BD;
      cursor: not-allowed;
    }

    .typework-color-l {
      color: #FFA726;
      cursor: not-allowed;
    }

    .typework-btn {
      width: 18%;
      text-align: center;
      padding: 10px;
      margin-bottom: -1px;

      @media (max-width:768px) {
        width: 20%;
        height: 90px;
        display: block;
        float: left;
        font-size: 14px;
        padding: 10px 5px;

        i {
          display: block;
        }
      }

      &.active-h {
        border-top: 3px solid #D32F2F;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-w {
        border-top: 3px solid #9E9E9E;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-s {
        border-top: 3px solid #0277BD;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-t {
        border-top: 3px solid #66BB6A;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-l {
        border-top: 3px solid #FFA726;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }
    }
  }
  .line-typework-group {
      border-top: 1px solid #E0E0E0;
  }
}

</style>


// WEBPACK FOOTER //
// inputChildTypework.vue?2b4fff22